import { graphql } from '../../../gql';

export const SAVE_REWRITE_MUTATION = graphql(`
  mutation saveRewrite($postId: ID!, $textBlocks: [TextBlockInput!]!) {
    saveRewrite(postId: $postId, textBlocks: $textBlocks) {
      id
      status
      savedSinceModeration
      analyzedSinceLastSave
      updatedAt
    }
  }
`);
